module.exports = __webpack_public_path__ + "static/media/finger_authen_red.f8a1cff6.svg";